import { render, staticRenderFns } from "./SelectedTextMenu.vue?vue&type=template&id=6d6b3326&scoped=true&"
import script from "./SelectedTextMenu.vue?vue&type=script&lang=js&"
export * from "./SelectedTextMenu.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTextMenu.vue?vue&type=style&index=0&id=6d6b3326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b3326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VIcon,VList,VListItem,VListItemTitle,VSlideXTransition})
